(function () {
  'use strict';

  var PLACEHOLDER_SELECTOR = 'script[data-defer-src]';
  var LOAD_AFTER_EVENT = 'load'; // wait until full page load to stay safest
  var MAX_WAIT_MS = 15000;       // safety cap per dependency chain
  var CHECK_INTERVAL_MS = 200;

  var state = {
    loaded: Object.create(null),
    started: Object.create(null),
    timers: Object.create(null)
  };

  function splitList(val) {
    if (!val) return [];
    return String(val)
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function markLoaded(id) {
    if (!id) return;
    state.loaded[id] = true;
    if (state.timers[id]) {
      clearTimeout(state.timers[id]);
      delete state.timers[id];
    }
  }

  function canStart(node) {
    var deps = splitList(node.getAttribute('data-after'));
    if (!deps.length) return true;
    for (var i = 0; i < deps.length; i++) {
      if (!state.loaded[deps[i]]) return false;
    }
    return true;
  }

  function inject(node) {
    var src = node.getAttribute('data-defer-src');
    var id  = node.getAttribute('data-id') || '';

    if (!src || state.started[id]) return;

    state.started[id] = true;

    var s = document.createElement('script');
    s.src = src;
    s.async = true; // dynamic scripts are async by default; keep it explicit
    // Copy type / integrity / crossorigin if present on the placeholder
    var type = node.getAttribute('type');
    if (type) s.type = type;
    var integrity = node.getAttribute('integrity');
    if (integrity) s.integrity = integrity;
    var crossorigin = node.getAttribute('crossorigin');
    if (crossorigin) s.crossOrigin = crossorigin;
    var referrerpolicy = node.getAttribute('referrerpolicy');
    if (referrerpolicy) s.referrerPolicy = referrerpolicy;

    s.addEventListener('load', function () { markLoaded(id); });
    s.addEventListener('error', function () { markLoaded(id); });

    // Insert just before the placeholder to preserve relative ordering
    node.parentNode.insertBefore(s, node);
  }

  function processPlaceholders(placeholders, startTime) {
    var pending = [];
    for (var i = 0; i < placeholders.length; i++) {
      var ph = placeholders[i];
      var id = ph.getAttribute('data-id') || '';
      if (state.loaded[id]) continue;         // already done
      if (state.started[id]) continue;        // already started
      if (canStart(ph)) {
        inject(ph);
        continue;
      }
      pending.push(ph);
    }

    // mark anything that has already loaded by URL duplication guard
    // (optional, but harmless)

    if (!pending.length) return; // all scheduled

    if ((Date.now() - startTime) > MAX_WAIT_MS) {
      // Failsafe: start remaining to avoid permanent block
      for (var j = 0; j < pending.length; j++) inject(pending[j]);
      return;
    }

    setTimeout(function () {
      processPlaceholders(pending, startTime);
    }, CHECK_INTERVAL_MS);
  }

  function start() {
    try {
      var placeholders = document.querySelectorAll(PLACEHOLDER_SELECTOR);
      if (!placeholders.length) return;

      // Any placeholders **without** an id should still load; assign an auto id so dependencies can’t reference them anyway.
      for (var i = 0; i < placeholders.length; i++) {
        var node = placeholders[i];
        var id = node.getAttribute('data-id');
        if (!id) node.setAttribute('data-id', 'defer-' + i);
      }

      processPlaceholders(placeholders, Date.now());
    } catch (e) {
      // Last-resort: if anything fails, load everything immediately
      var fallbacks = document.querySelectorAll(PLACEHOLDER_SELECTOR);
      for (var k = 0; k < fallbacks.length; k++) inject(fallbacks[k]);
    }
  }

  // Run after full page load (most conservative/safe)
  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener(LOAD_AFTER_EVENT, start, { once: true });
  }
})();
